import { useState, useEffect, useCallback, useRef } from 'react';
import { getAiUsage, getCompanies } from './api';

// One fetch per filter change; stale responses are dropped (fetchIdRef), as in
// sessions/useSessions.js.
export default function useAiUsage(filters) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [companies, setCompanies] = useState([]);
    const fetchIdRef = useRef(0);

    const fetch = useCallback(async () => {
        const id = ++fetchIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const params = { ...filters };
            Object.keys(params).forEach((k) => {
                if (params[k] === '' || params[k] === undefined || params[k] === null) delete params[k];
            });
            const res = await getAiUsage(params);
            if (id === fetchIdRef.current) setData((res && res.data) || null);
        } catch (err) {
            if (id === fetchIdRef.current) setError(err.message || 'Failed to load AI usage');
        } finally {
            if (id === fetchIdRef.current) setLoading(false);
        }
    }, [JSON.stringify(filters)]); // filters is a fresh object each render; its serialised form is the real dependency

    useEffect(() => { fetch(); }, [fetch]);

    useEffect(() => {
        getCompanies()
            .then((res) => {
                const list = Array.isArray(res) ? res : (res && (res.data || res.companies)) || [];
                setCompanies((Array.isArray(list) ? list : []).map((c) => ({ id: c.id, name: c.name })));
            })
            .catch(() => setCompanies([]));
    }, []);

    return {
        data, loading, error, companies, refetch: fetch,
    };
}
